import './layer-control.styl';

class LayerControl {
  constructor() {
    this._container = null;
    this._map = null;
    this._button = null;
    this._handleOnline = null;
    this._handleOffline = null;
  }

  onAdd(map) {
    this._map = map;

    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group layer-control';

    this._button = document.createElement('button');
    this._button.className = 'layer-control__button my-tenth-risk-step';
    this._button.type = 'button';
    this._button.setAttribute('aria-label', 'Toggle satellite layer');

    this._button.addEventListener('click', this._toggleLayer.bind(this));

    this._handleOnline = () => this._updateButtonState();
    this._handleOffline = () => this._updateButtonState();

    window.addEventListener('online', this._handleOnline);
    window.addEventListener('offline', this._handleOffline);

    this._container.appendChild(this._button);

    return this._container;
  }

  _updateButtonState() {
    this._button.disabled = !navigator.onLine;
  }

  onRemove() {
    if (this._button) {
      this._button.removeEventListener('click', this._toggleLayer.bind(this));
    }

    if (this._handleOnline) {
      window.removeEventListener('online', this._handleOnline);
    }
    if (this._handleOffline) {
      window.removeEventListener('offline', this._handleOffline);
    }

    if (this._container && this._container.parentNode) {
      this._container.parentNode.removeChild(this._container);
    }

    this._container = null;
    this._button = null;
    this._map = null;
    this._handleOnline = null;
    this._handleOffline = null;
  }

  _toggleLayer() {
    if (!this._map) return;

    const layerId = 'satellite';

    const layer = this._map.getLayer(layerId);
    if (!layer) {
      console.warn(`Layer '${layerId}' not found`);
      return;
    }

    const visibility = this._map.getLayoutProperty(layerId, 'visibility');
    this._container.classList.toggle('layer-control--active');

    if (visibility === 'visible' || visibility === undefined) {
      this._map.setLayoutProperty(layerId, 'visibility', 'none');
      this._map.setPaintProperty('kasungu-outline', 'line-color', '#6E6E6E');
    } else {
      this._map.setLayoutProperty(layerId, 'visibility', 'visible');
      this._map.setPaintProperty('kasungu-outline', 'line-color', '#D4D4D4');
    }
  }
}

export default LayerControl;